// import moment from 'moment';

export const templeInfo = {
  name: 'Sri Sringeri Shankar Math',
  legalName: 'SRI SRI J.S.M.D. SRI SHARADA PEETHAM, SRINGERI',
  address: 'University Road, Nallakunta,Hyderabad, Telangana – 500 044',
  contact: 'Phone Numbers: 040-27667783'
};

export const history =
  'The branch math at Nallakunta is the oldest of the branch maths of the Sringeri Math in Hyderabad. The land on which the present Math and temple complex are located were donated to the math by the Late Sri Raja Venkata Rao Limbekar as a token of.....';

export const fullHistory = `The branch math at Nallakunta is the oldest of the branch maths of the Sringeri Math in Hyderabad. The land on which the present Math and temple complex are located were donated to the math by the Late Sri Raja Venkata Rao Limbekar as a token of his love and devotion to the 34th Jagadguru Shankaracharya Sri Sri Chandrashekhara Bharathi Mahaswamiji. Above this, he also constructed the temples of Sri Sharadamba and Sri Adi Shankaracharya.

The Pratishtha kumbhabhishekam of the temples was performed by the 35th Jagadguru Shankaracharya Sri Sri Abhinava Vidyatirtha Mahaswamiji on the auspicious day of Akshaya Tritiya in the year 1960 – April 26 1960.

Since then, the temple and the Math have served as a focal point of spiritual activities to the community of Astikas and followers of Sanatana Dharma in the city of Hyderabad.`;

// For copying image SRCs, upload to google photos and inspect the element and copy the src
export const announcements = [
  {
    createdDate: '17-09-2026',
    title: 'Dasara Navaratri Poojas 2026',
    information: [
      `Dasara Navaratri poojas from 10th October 2026 to 21st October 2026 have been opened for booking`,
      `1. Mahabhishekam on 10th October 2026`,
      `2. Chandi Parayana (1 Day / 9 Days), Dasara Suvasini Pooja, Sarva Seva and Dasara Udayastamana Pooja from 10th October 2026 to 21st October 2026`,
      `3. Navaratri Chandi Homa Kanuka on 20th October 2026`,
      `4. Dasara (Vijayadashami) on 21st October 2026`
    ]
  },
  {
    createdDate: '17-09-2026',
    title: 'Sri Shakti Ganapati Navaratra Utsavamulu 2026',
    information: [
      `Sri Shakti Ganapati Navaratra Utsavamulu from Monday 14-09-2026 to Tuesday 22-09-2026 at Sringeri Shankaramath, Nallakunta, Hyderabad`,
      `1. Ganapati Homam - every day from 14-09-2026 to 22-09-2026`,
      `2. Durvarchana (Durvashtami Durva/Garika Puja) on 19-09-2026 at 9:00 am`,
      `3. Shakti Ganapati Abhishekam - every day from 14-09-2026 to 22-09-2026`,
      `Sri Ganesha Vaibhavam Pravachanam by Sri Malladi Venkata Ramanatha Sarma daily from 6:00 pm to 7:00 pm, followed by cultural programmes daily from 7:00 pm to 8:15 pm`
    ],
    src: [
      'https://res.cloudinary.com/ddhhzhfsa/image/upload/f_auto,q_auto/temple/announcements/ganapati-navaratri-2026-invitation-telugu.jpg',
      'https://res.cloudinary.com/ddhhzhfsa/image/upload/f_auto,q_auto/temple/announcements/ganapati-navaratri-2026-invitation-english.jpg',
      'https://res.cloudinary.com/ddhhzhfsa/image/upload/f_auto,q_auto/temple/announcements/shakti-ganapati.jpg',
      'https://res.cloudinary.com/ddhhzhfsa/image/upload/f_auto,q_auto/temple/announcements/sringeri-ganapatulu.jpg'
    ]
  },
  {
    createdDate: '22-01-2025',
    title: 'The poojas for shivaratri and sri panchami have been opened for booking',
    information: [`Devotees can now book the poojas for 2026`]
  },
  {
    createdDate: '16-12-2025',
    title: 'The poojas for 2026 have been opened for booking',
    information: [`Devotees can now book the poojas for 2026`],
    src: 'https://photos.fife.usercontent.google.com/pw/AP1GczN3136JvEX8XbG5821XTR9_2fiKgUggV_fuMOcwR932MwjkNDeDHme-=w798-h1596-s-no-gm?authuser=1'
  },
  {
    createdDate: '2-09-2025',
    title: 'Dasara Navaratri Poojas',
    information: [
      `Navratri Poojas from 21st September 2025 to 2nd October 2025 have been opened for booking`
    ],
    src: 'https://drive.google.com/file/d/1vWJK4Pebb6P2FzLfnw8j-knk_Zwvkm3L/view?usp=drive_link'
  },
  {
    createdDate: '2-09-2025',
    title: 'Grahana Shanti Pooja',
    information: [
      `Grahana Shanti pooja on 8th September 2025 has been opened for booking`
    ]
  },
  {
    createdDate: '20-04-2025',
    title: 'Event Information',
    information: [`Event information brochures could be found below`]
  },
  {
    createdDate: '20-04-2025',
    title:
      'The poojas for Chandi Saptashiti Parayanamu and Sri Lakshmi Narayan Hnadayamu Parayanamu have been opened for booking',
    information: [
      `Devotees can now book the poojas for Chandi Saptashiti Parayanamu and Sri Lakshmi Narayan Hnadayamu Parayanamu`
    ]
  },
  {
    createdDate: '28-01-2025',
    title: 'The poojas for Maha Shivaratri 2025 have been opened for booking',
    information: [`Devotees can now book the Mahashivaratri poojas for 2025`]
  },
  {
    createdDate: '31-12-2024',
    title: 'The poojas for 2025 have been opened for booking',
    information: [`Devotees can now book the poojas for 2025`]
  },
  {
    createdDate: '27-09-2024',
    title: 'The poojas for Dasara Navratri have been opened for booking',
    information: [`Devotees can now book the poojas for Dasara Navaratri`]
  },

  {
    createdDate: '27-09-2024',
    title: 'The event information for Dasara Navaratri',
    information: [
      `Please find the event information of Dasara Navaratri below`
    ],
    src: 'https://drive.google.com/file/d/1W8zjHpzhLx9XpSUQ4P-eM4TDLjIy0J1J/view?usp=drive_link'
  },
  {
    createdDate: '01-09-2024',
    title: 'The prices for Poojas have been updated',
    information: [
      `The prices for poojas have been updated. In the image below, you could check the new prices of Poojas`
    ],
    src: 'https://lh3.googleusercontent.com/pw/AP1GczMUd5Nq1RQa6LJnMhYDjt_3MFkN7Tj2njCYIQM2CjKWPCSy4szxtFg36ESdi73DIJhNuYcq7R3aD5AcBgTh9ePdiNiBjIrfGC171WKvRhGFspSK51wI6u51GOGQGSLRBpZZpFtPYJh2m0yWuXuhvck=w1129-h400-s-no'
  },
  {
    createdDate: '15-04-2024',
    title: 'Pooja opened for the Sri Rama Kalyanam',
    information: [
      `Pooja (Sita Rama kalyanam) for the Sri Ramanavami 2024 have been opened for booking`
    ]
  },
  {
    createdDate: '29-02-2024',
    title: 'Poojas opened for the Maha shivaratri',
    information: [
      `Poojas for the Mahashivaratri 2024 have been opened for booking`
    ]
  },
  {
    createdDate: '21-01-24',
    title: 'Rama Kalyanam on 22-01-2024',
    information: [
      `Rama kalyanam to be performed at the temple premises on 22-01-2024 on the occassion of Rama Prana Prathishtapana in Ayodhya.
      Sri Rama thryodashi , Sri Sita Ramula Kalyanam and Sri Rama mantra Homamu Purnahuti to be performed. Find the details in the below link:
      `
    ],
    src: 'https://lh3.googleusercontent.com/pw/ABLVV844SVRKpS3xcGu2WigIW1Bio7xdTbtCw9zWCQ0RMywtBX9WdzubSCbcTJPgbGQXuFgyHIGlHtASCKSuhB5SeF5e3sKCjbyqbmAf53AUEN71Tb5WLHFNG2p7IGZa-KNSONSm_hZ_lgkByzLpjY3jSAU=w413-h820-s-no?authuser=0'
  },
  {
    createdDate: '1-01-24',
    title: 'Poojas opened for the calendar year 2024',
    information: [`Nitya Poojas for the year 2024 have been opened for booking`]
  },
  {
    createdDate: '1-10-23',
    title: 'Dussehra Navaratri Poojas',
    information: [`Poojas for Dussehra Navratri have been opened`]
  },
  {
    createdDate: '21-03-23',
    title: 'Sri Sita Rama Kalyanam',
    information: [`Poojas for Sita Rama kalyanam have been opened`]
  },
  {
    createdDate: '14-03-23',
    title: 'Downloading Receipts',
    information: [
      `Devotees can now download receipts from Seva History page for the transactions`
    ]
  },
  {
    createdDate: '14-02-23',
    title: 'Sevas For Mahashivratri have been opened',
    information: [
      `Sevas for Mahashivaratri have been opened for Feb 18, 2023 and Girija Kalyanam on Feb 19, 2023`
    ]
  },
  {
    createdDate: '26-09-22',
    title: 'Dasara sevas opened for booking',
    information: [
      `Following Dasara sevas have been opened on their respective dates: `,
      `1. Lakshma Kumukumarchana will not be performed on 8th November, 2022 (Because of Lunar Eclipse/ Chandra Grahanam)`,
      `2. Karthika Masam dates - 26/10/2022 to 23/11/2022`,
      `3. Chandi Parayana 1 Day for 9 days - 26th September 2022 to 04th October, 2022`,
      `4. Chandi Parayana 9 days from 26th September 2022 to 04th October, 2022 `,
      `5. Dasara Sevas and Sarva Sevas have been opened`,
      `6. Mahabhishekam opened for 25th September, 2022`,
      `7. Dasara Chandi Homa Kanuka seva opened for 4th October, 2022`
    ]
  },
  {
    createdDate: '12-09-21',
    title: 'UPI and Mobile Payment Issues have been resolved',
    information: [
      'Devotees can now book through UPI payments and through any option in the payment gateway. Please report if any issues to the temple authorities.'
    ]
  },
  {
    createdDate: '07-09-21',
    title: 'Pooja Booking dates opened for Ganapathi Navaratri',
    information: [
      'Devotees can book for Ganapathi Navaratri Homam from 11-09-2021 to 18-09-2021 and also for Sahashra Modaka Ganapathi Homa Sahitha Abhishekam on 10-09-2021.'
    ]
  },
  {
    createdDate: '03-03-21',
    title: 'Pooja Booking dates opened for Maha Shivaratri',
    information: [
      'Devotees can book for Lingodbhava Kala Abhishekam on 11th March, 2021 and Girija Kalyanam poojas on 12th March, 2021 .'
    ]
  },
  {
    createdDate: '21-02-21',
    title: 'Pooja Booking dates opened till Dec 31, 2021',
    information: [
      'Devotees can book for regular poojas and special/occassional till December 31, 2021.'
    ]
  }
];
